import React, {FC, useState} from 'react';

import {Map} from '@geomatico/geocomponents';

import {INITIAL_VIEWPORT} from '@/config';
import {Polygon} from 'geojson';
import GeometryEditor from '@/components/map/GeometryEditor';

export type MainContentProps = {
  mapStyle: string,
  isGeometryEditorOpen: number, // numérico para forzar remount de GeometryEditor
  onPolygonChange: (geom: Polygon) => void
};

const MainContent: FC<MainContentProps> = ({mapStyle, isGeometryEditorOpen, onPolygonChange}) => {
  const [viewport, setViewport] = useState(INITIAL_VIEWPORT);

  return <Map
    mapStyle={mapStyle}
    viewport={viewport}
    onViewportChange={setViewport}
  >
    {
      isGeometryEditorOpen && (
        <GeometryEditor key={isGeometryEditorOpen} onPolygonChange={onPolygonChange} />
      )
    }
  </Map>;
};

export default MainContent;
